import { render } from "./UserGroups.vue?vue&type=template&id=32c40b43&scoped=true"
import script from "./UserGroups.vue?vue&type=script&lang=js"
export * from "./UserGroups.vue?vue&type=script&lang=js"

import "./UserGroups.vue?vue&type=style&index=0&id=32c40b43&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c40b43"]])

export default __exports__